import * as types from '../../reduxStore/types/orders';

export const removeCompletedOrder = (orderId) => {
    return {
        type: types.REMOVE_COMPLETED_ORDER,
        payload: orderId,
    };
};
